import { render, staticRenderFns } from "./HTTPError.vue?vue&type=template&id=2044b177&scoped=true"
import script from "./HTTPError.vue?vue&type=script&lang=js"
export * from "./HTTPError.vue?vue&type=script&lang=js"
import style0 from "./HTTPError.vue?vue&type=style&index=0&id=2044b177&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2044b177",
  null
  
)

export default component.exports